import { Injectable } from '@angular/core';
import { ConfigManagerService } from '@xpo-ltl/config-manager';


import { DocumentManagementV2ApiService, DocumentSearch, GetDocumentPath, GetDocumentResp, SearchDmsDocumentPath, SearchDmsDocumentResp, SearchDmsDocumentRqst } from '@xpo-ltl-2.0/sdk-documentmanagementv2';

import * as _ from 'lodash';
import { get as _get, maxBy as _maxBy, size as _size } from 'lodash';

import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, concatMap, take } from 'rxjs/operators';

import { DmsFile } from './model/dms-file';
import { DocumentRequest } from './model/dms-document-response';

import { ConfigManagerProperties, DocType } from '@shared/enums';

@Injectable({ providedIn: 'root' })
export class DmsApiService {

  constructor(
    private config: ConfigManagerService,
    private documentManagementV2ApiService: DocumentManagementV2ApiService
  ) {}

  getDocument(request: GetDocumentPath): Observable<GetDocumentResp> {
    return this.documentManagementV2ApiService.getDocument(request, {multiPartResp: true});
  }

  getDmsDocument(documentRequest: DocumentRequest): Observable<DmsFile> {
    const mySubject = new BehaviorSubject<DmsFile>(null);
    const { referenceNumber, minDateTime, maxDateTime } = documentRequest;
    let docArchiveTimestamp;
    let listDocuments$: Observable<SearchDmsDocumentResp>;

    if (documentRequest.docType === DocType.InvoicePdf) {
      listDocuments$ = of(null);
    } else {
      listDocuments$ = this.listAvailableDocuments$(referenceNumber, minDateTime, maxDateTime);
    }

    listDocuments$
      .pipe(
        concatMap((documentListResponse: SearchDmsDocumentResp) => {
          if (!documentListResponse) {
            docArchiveTimestamp = documentRequest.referenceNumber;
          } else {
            let files = documentListResponse.documentInfo.filter(
              (dmsFile: DocumentSearch) =>
                dmsFile.cdt.docClass === documentRequest.docType && dmsFile.timestampISO < maxDateTime
            );
            files = _.orderBy(files, ['timestampISO'], ['desc']);
            docArchiveTimestamp = files[0].cdt.timestamp;
          }

          const request: GetDocumentPath = {
            corpCode: this.config.getSetting<string>(ConfigManagerProperties.imageCorpCode),
            docClass: documentRequest.docType,
            docArchiveTimestamp,
            docFormat: 'pdf'
          };
          return this.getDocument(request);
        }),
        take(1)
      )
      .subscribe(
        (success) => {
          const file = this.dataURLtoUint8Array(`data:${success.contentType};base64,${success.documentData}`);
          mySubject.next({ fileSize: null, file });
        },
        (error) => {
          if (_.result(error, 'error.errorCode', undefined)) {
            mySubject.error(`${_.result(error, 'error.message', '')}`);
          } else {
            mySubject.error('No data found');
          }
        }
      );

    return mySubject.asObservable();
  }

  listAvailableDocuments$(
    proNumber: string,
    minDateTime: string = null,
    maxDateTime: string = null
  ): Observable<SearchDmsDocumentResp> {
    const request: SearchDmsDocumentRqst = {
      searchString: proNumber,
      minDateTime,
      maxDateTime
    } as SearchDmsDocumentRqst;
    const queryParams: SearchDmsDocumentPath = {
      corpCode: this.config.getSetting<string>(ConfigManagerProperties.imageCorpCode)
    }
    
    return this.documentManagementV2ApiService.searchDmsDocument(request, queryParams).pipe(
      take(1),
      catchError((error) => {
        return of(undefined);
      })
    );
  }

  dataURLtoUint8Array(dataurl: string): Uint8Array {
    const arr = dataurl.split(',');
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return u8arr;
  }
}
